<template>
 <b-container fluid>
    <b-row class="mb-5" >
      <b-col lg="3">
        <!-- <h5>Ajouts</h5> -->
        <div class="border-bottom mb-3">
          <b-button
            v-b-modal.modal-typologies
            variant="primary"
            block
            class="mb-3"
          >
            Typologies
          </b-button>
       
        </div>
      </b-col>
    </b-row>
    <ModalTypology />

 </b-container>

</template>

<script>
    import ModalTypology from "./ModalTypology";

export default {


  name: "CharacteristicsManagement",
  data() {
    return {
    
    };
  },
  components: {
          ModalTypology
  },
  mounted() {
   
  },
  methods: {
    
  },
  watch: {},
  computed: {
 
  },
};
</script>
<style>

</style>
